import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { caseStudies } from '@/data/mock';

export default function CaseStudiesPage() {
  return (
    <div>
      {/* Hero */}
      <section className="bg-vine-deep text-vine-warm">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-36">
          <div className="max-w-3xl">
            <div className="w-12 h-px bg-copper mb-10" />
            <span className="section-label block mb-5">Case Studies</span>
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-light leading-[1.1] tracking-tight mt-4">
              Systems that survive growth.
            </h1>
            <p className="mt-8 text-lg text-vine-neutral/70 leading-relaxed max-w-xl font-light">
              Six transformation arcs. No fluff. No exaggerated claims. Just structural progression across 12 months.
            </p>
          </div>
        </div>
      </section>

      {/* Common Arc */}
      <section className="bg-vine-warm border-b border-vine-neutral/15">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
          <div className="flex flex-wrap items-center gap-8 md:gap-16">
            <div className="flex items-center gap-3">
              <span className="text-copper text-[12px] tracking-[0.2em] uppercase font-medium">Month 3</span>
              <span className="text-vine-primary/50 text-[14px]">Clarity &amp; structural correction</span>
            </div>
            <div className="w-8 h-px bg-copper/30 hidden md:block" />
            <div className="flex items-center gap-3">
              <span className="text-copper text-[12px] tracking-[0.2em] uppercase font-medium">Month 6</span>
              <span className="text-vine-primary/50 text-[14px]">Stability &amp; reduced volatility</span>
            </div>
            <div className="w-8 h-px bg-copper/30 hidden md:block" />
            <div className="flex items-center gap-3">
              <span className="text-copper text-[12px] tracking-[0.2em] uppercase font-medium">Month 12</span>
              <span className="text-vine-primary/50 text-[14px]">Governable scale</span>
            </div>
          </div>
        </div>
      </section>

      {/* Case Study Grid */}
      <section className="bg-vine-warm">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {caseStudies.map((cs) => (
              <Link
                key={cs.id}
                to={`/case-studies/${cs.slug}`}
                className="group p-8 md:p-10 border border-vine-neutral/20 bg-white/40 hover-lift block"
              >
                <span className="text-[11px] text-copper tracking-[0.2em] font-medium">
                  Case {cs.number}
                </span>
                <h3 className="font-display text-2xl md:text-3xl text-vine-primary font-light mt-3 mb-3 group-hover:text-copper transition-colors duration-300">
                  {cs.title}
                </h3>
                <p className="text-vine-primary/50 text-[13px] tracking-[0.05em] uppercase mb-5">
                  {cs.icp}
                </p>
                <p className="text-vine-primary/60 text-[14px] leading-relaxed line-clamp-3 mb-6">
                  {cs.situation.split('\n')[0]}
                </p>
                <div className="flex items-center gap-2 text-copper text-[13px] tracking-[0.08em] uppercase group-hover:gap-3 transition-all duration-300">
                  Read case study <ArrowRight size={14} />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom statement */}
      <section className="bg-vine-deep text-vine-warm">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 md:py-28 text-center">
          <p className="font-display text-2xl md:text-3xl font-light max-w-2xl mx-auto leading-relaxed">
            Copper &amp; Vine does not create hype cycles.<br />
            We build systems that survive growth.
          </p>
        </div>
      </section>
    </div>
  );
}
